<template>
  <section class="lookup">
    <div class="lookup__head">
      <h2>Platform Lookup</h2>
      <a
        @click.prevent="goBackEvent"
        href="#"
        class="link--go-back"
      >
        Go Back
      </a>
    </div>
    <section class="lookup__body">
      <div class="body__left">
        <div class="body__v-bar-content">
          <div class="body__content">
            <div class="lookup__search">
              <form @submit.prevent="search">
                <div class="lookup__search--input">
                  <unum-textbox
                    name="lookupTerms"
                    label="Search Platforms"
                    placeholder="Search Platforms"
                    v-model.trim="lookupTerms"
                    hideLabel
                    noMargin
                    @input="closeCompareDrawer"
                  />
                  <span
                    v-if="lookupTerms.length > 0"
                    @click.prevent="clearLookupTerms"
                    class="lookup__search--clear-search">
                    Clear Search
                  </span>
                </div>
                <unum-button :color="'green'">Search</unum-button>
              </form>
            </div>
            <section class="results results--preferred">
              <header class="results__header"><h3>Preferred Solutions</h3></header>
              <transition-group
                name="results"
                tag="ul"
                class="results__list"
                v-if="results.length"
              >
                <li
                  v-for="(platform, index) in preferredPlatformsSorted"
                  v-bind:key="platform['.key']"
                  v-bind:data-index="index"
                  :class="{'results--currentPlatform': isCurrent(platform)}"
                >
                  <p
                    :id="'key-' + platform['.key']"
                    :data-platform-key="platform['.key']"
                    @click="setCurrentPlatform(platform); closeCompareDrawer();"
                  >
                    {{platform.displayName}}
                    <span
                      v-if="is.dev"
                      class="platform-priority"
                    >
                      priority: {{ platformPriority(platform.priority) }}
                    </span>
                  </p>
                  <unum-button
                    small
                    outline
                    color="red"
                    v-if="isChosen(platform)"
                    @click.native="removePlatformEvent(platform)"
                  >
                    Remove
                  </unum-button>
                </li>
              </transition-group>
            </section>

            <section class="results results--fully-integrated">
              <header class="results__header"><h3>Fully Integrated</h3></header>
              <transition-group
                name="results"
                tag="ul"
                class="results__list"
                v-if="results.length"
              >
                <li
                  v-for="(platform, index) in fullyIntegratedPlatformsSorted"
                  v-bind:key="platform['.key']"
                  v-bind:data-index="index"
                  :class="{'results--currentPlatform': isCurrent(platform)}"
                >
                  <p
                    :id="'key-' + platform['.key']"
                    :data-platform-key="platform['.key']"
                    @click="setCurrentPlatform(platform); closeCompareDrawer();"
                  >
                    {{platform.displayName}}
                    <span
                      v-if="is.dev"
                      class="platform-priority"
                    >
                      priority: {{ platformPriority(platform.priority) }}
                    </span>
                  </p>
                  <!-- <p
                    v-if="platform.caseSizeMinimum"
                  >
                    {{ platform.caseSizeMinimum }}
                  </p> -->
                  <unum-button
                    small
                    outline
                    color="red"
                    v-if="isChosen(platform)"
                    @click.native="removePlatformEvent(platform)"
                  >
                    Remove
                  </unum-button>
                </li>
              </transition-group>
            </section>

            <section class="results results--future-integration">
              <header class="results__header"><h3>Future Integration</h3></header>
              <transition-group
                name="results"
                tag="ul"
                class="results__list"
                v-if="results.length"
              >
                <li
                  v-for="(platform, index) in futureIntegrationPlatformsSorted"
                  v-bind:key="platform['.key']"
                  v-bind:data-index="index"
                  :class="{'results--currentPlatform': isCurrent(platform)}"
                >
                  <p
                    :id="'key-' + platform['.key']"
                    :data-platform-key="platform['.key']"
                    @click="setCurrentPlatform(platform); closeCompareDrawer();"
                  >
                    {{platform.displayName}}
                    <span
                      v-if="is.dev"
                      class="platform-priority"
                    >
                      priority: {{ platformPriority(platform.priority) }}
                    </span>
                  </p>
                  <unum-button
                    small
                    outline
                    color="red"
                    v-if="isChosen(platform)"
                    @click.native="removePlatformEvent(platform)"
                  >
                    Remove
                  </unum-button>
                </li>
              </transition-group>
            </section>

            <section class="results results--product-hosted">
              <header class="results__header">
                <h3>Product Hosted</h3>
              </header>
              <transition-group
                name="results"
                tag="ul"
                class="results__list"
                v-if="results.length"
              >
                <li
                  v-for="(platform, index) in productHostedSortedResults"
                  v-bind:key="platform['.key']"
                  v-bind:data-index="index"
                >
                  <p
                    :id="'key-' + platform['.key']"
                    :data-platform-key="platform['.key']"
                    @click="viewFinal(platform); closeCompareDrawer();"
                  >
                    {{platform.displayName}}
                  </p>
                  <unum-button
                    small
                    outline
                    color="red"
                    v-if="isChosen(platform)"
                    @click.native="removePlatformEvent(platform)"
                  >
                    Remove
                  </unum-button>
                </li>
              </transition-group>
            </section>

            <transition name="fade">
              <section
                class="results results--not-integrated"
                v-if="lookupTerms.length > 0"
              >
                <unum-button
                  @click.native.prevent="noPlatform"
                >
                  Don't See your platform?
                </unum-button>
              </section>
            </transition>
          </div>
        </div>
      </div>
      <div class="body__right">
        <div class="body__v-bar-content">
          <transition name="fade">
            <template v-if="this.currentPlatform">
              <router-view
                v-if="this.currentPlatform.status !== 'product_hosted'"
              />
            </template>
          </transition>
          <template v-if="!this.currentPlatform">
            <div class="lookup__unselected">
              <unum-button
                @click.native.prevent="noPlatform"
              >
                Don't See Your Platform?
              </unum-button>
            </div>
          </template>
          <template v-if="this.currentPlatform">
            <div
              v-if="this.currentPlatform.status === 'product_hosted'"
              class="lookup__unselected"
            >
              <unum-button
                @click.native.prevent="noPlatform"
              >
                Don't See Your Platform?
              </unum-button>
            </div>
          </template>
        </div>
      </div>
      <unum-drawer-compare />
    </section>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'

// import Velocity from 'velocity-animate'

import UnumDrawerCompare from '@/components/layout/DrawerCompare'
import UnumTextbox from '@/components/ui/Textbox'
import UnumButton from '@/components/ui/Button'

import { db } from '@/appConfig/appConfig'
import sessionEvent from '@/util/sessionEvent'

export default {
  name: 'Lookup',
  props: ['viewingPlatformKey'],
  components: {
    UnumDrawerCompare,
    UnumTextbox,
    UnumButton
  },
  data () {
    return {
      featureSettings: {},
      lookupTerms: '',
      // platforms: [],
      results: '',
      vFuseOptions: {
        keys: ['displayName'],
        threshold: 0.2
        // tokenize: true
      }
    }
  },
  async created () {
    this.setPlatforms(await this.platforms)
    this.results = await this.platforms

    const featureSettings = await db.ref('blueprints/sections').once('value')
      .then(function (featureSectionsBlueprint) {
        let featureSettings = {}
        Object.entries(featureSectionsBlueprint.val())
          .forEach(featureKey => {
            featureSettings[featureKey[0]] = featureKey[1].collapsed
          })
        return featureSettings
      })
    this.$store.dispatch('shared/setFeatureSectionSettings', featureSettings)

    if (this.viewingPlatformKey) {
      const platformToView = this.platforms.filter(platform => {
        return platform['.key'] === this.viewingPlatformKey
      })
      if (platformToView[0]) {
        this.$store.dispatch('platforms/setCurrentPlatform', platformToView[0])
      }
    }
  },
  // async beforeMount () {
  //   if (this.filteredPlatforms.length > 0) {
  //     console.log('FILTERED PLATFORMS')
  //     this.setPlatforms(await this.filteredPlatforms)
  //     this.results = await this.filteredPlatforms
  //   } else {
  //     console.log('ALL PLATFORMS')
  //     this.setPlatforms(await this.platforms)
  //     this.results = await this.platforms
  //   }
  // },
  // firebase: {
  //   platforms: {
  //     source: db.ref('platforms').orderByChild('published').equalTo(true),
  //     readyCallback (thing) {
  //       console.log('[Lookup.vue] - LOADED PLATFORMS')
  //     }
  //   }
  // },
  methods: {
    ...mapActions('platforms', [
      'setPlatforms',
      'addPlatform',
      'removePlatform',
      'togglePlatform',
      // 'setCurrentPlatform',
      'clearCurrentPlatform',
      'clearPlatformSelection',
      'clearChosenPlatforms',
      'platformSelection'
    ]),
    ...mapActions('platforms', {
      setCurrentPlatformVuex: 'setCurrentPlatform'
    }),
    ...mapActions('shared', [
      'closeCompareDrawer'
    ]),
    ...mapActions('wizard', [
      'clearWizard'
    ]),
    setCurrentPlatform (platform) {
      console.log(platform)
      const sessionKey = this.$storage.get('session_key')
      let platformState = 'selected'
      if (!this.isCurrent(platform)) {
        this.setCurrentPlatformVuex(platform)
      } else {
        platformState = 'deselected'
        this.clearCurrentPlatform()
      }
      sessionEvent(sessionKey, 'clicked_lookup_platform', {
        platform: platform.displayName,
        state: platformState
      })
    },
    isChosen (platformCheck) {
      if (this.chosenPlatforms
        .find(platform => platform.displayName === platformCheck.displayName)) return true
      return false
    },
    isCurrent (platform) {
      if (platform && this.currentPlatform) {
        if (platform.displayName === this.currentPlatform.displayName) {
          return true
        }
      }
    },
    search () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'submit_lookup_search', { search_term: this.lookupTerms })
      this.$search(this.lookupTerms, this.platforms, this.vFuseOptions)
        .then(results => {
          if (!results.length && !this.lookupTerms) {
            this.results = this.platforms
            return
          }
          this.results = results
        })
    },
    clearLookupTerms () {
      this.lookupTerms = ''
      this.search()
    },
    noPlatform () {
      console.log('no platform!')
      this.clearCurrentPlatform()
      this.clearPlatformSelection()

      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_lookup_no_results_button', null, { fromPath: 'Lookup' })

      if (this.lookupTerms.length > 0) {
        console.log(this.lookupTerms)
        this.$router.push({
          name: 'FinalSelection',
          query: { unknownPlatform: this.lookupTerms }
        })
      } else {
        this.$router.push({ name: 'FinalSelection' })
      }
    },
    viewFinal (platform) {
      // console.log(platform)
      this.platformSelection(platform)
        .then(res => {
          const sessionKey = this.$storage.get('session_key')
          sessionEvent(sessionKey, 'made_final_selection',
            {
              platform: platform.displayName,
              platformKey: platform['.key']
            }, { fromPath: 'Lookup' })
          this.$router.push({ name: 'FinalSelection' })
        })
        .catch(err => {
          console.error(err)
        })
    },
    goBackEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_back_link', {
        to: this.$store.state.route.from.fullPath
      })
      this.$router.go(-1)
    },
    removePlatformEvent (platform) {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_lookup_remove_platform_button', {
        platform: platform.displayName
      })
      this.removePlatform(platform)
    },
    platformPriority (priority) {
      if (typeof priority === 'string') {
        if (priority.length) {
          return parseInt(priority, 10)
        }
        return 0
      }
      return '0, not set'
    }
    //
    // Velocity animation methods
    //
    // resultsBeforeEnter (el) {
    //   el.style.opacity = 0
    //   el.style.maxHeight = 0
    // },
    // resultsEnter (el, done) {
    //   var delay = el.dataset.index * 50
    //   setTimeout(() => {
    //     Velocity(
    //       el,
    //       { opacity: 1, maxHeight: 420 }
    //     )
    //   }, delay)
    // },
    // resultsLeave (el, done) {
    //   var delay = el.dataset.index * 50
    //   setTimeout(() => {
    //     Velocity(
    //       el,
    //       { opacity: 0, height: 0, padding: 0, border: 0 }
    //     )
    //   }, delay)
    // }
  },
  computed: {
    ...mapState('platforms', [
      'platforms',
      'chosenPlatforms',
      'currentPlatform'
    ]),
    ...mapState('shared', [
      'is'
    ]),
    preferredPlatformsSorted () {
      const preferredResults = this.results.filter(platform => {
        return !!platform.preferred
      }).sort(function (a, b) {
        return a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1
          : b.displayName.toLowerCase() > a.displayName.toLowerCase() ? -1
            : 0
      })
      return preferredResults.sort(function (a, b) {
        // Account for cases where the platform's priority property doesn't exist
        const aPriority = a.priority ? parseInt(a.priority, 10) : 0
        const bPriority = b.priority ? parseInt(b.priority, 10) : 0
        return aPriority > bPriority ? 1 : bPriority > aPriority ? -1 : 0
      })
    },
    fullyIntegratedPlatformsSorted () {
      const fullyIntegratedResults = this.results.filter(platform => {
        return !platform.preferred && platform.status === 'fully_integrated'
      }).sort(function (a, b) {
        return a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1
          : b.displayName.toLowerCase() > a.displayName.toLowerCase() ? -1
            : 0
      })
      return fullyIntegratedResults.sort(function (a, b) {
        // Account for cases where the platform's priority property doesn't exist
        const aPriority = a.priority ? parseInt(a.priority, 10) : 0
        const bPriority = b.priority ? parseInt(b.priority, 10) : 0
        return aPriority > bPriority ? 1 : bPriority > aPriority ? -1 : 0
      })
    },
    futureIntegrationPlatformsSorted () {
      const futureIntegrationResults = this.results.filter(platform => {
        return !platform.preferred && platform.status === 'future_integration'
      }).sort(function (a, b) {
        return a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1
          : b.displayName.toLowerCase() > a.displayName.toLowerCase() ? -1
            : 0
      })
      return futureIntegrationResults.sort(function (a, b) {
        // Account for cases where the platform's priority property doesn't exist
        const aPriority = a.priority ? parseInt(a.priority, 10) : 0
        const bPriority = b.priority ? parseInt(b.priority, 10) : 0
        return aPriority > bPriority ? 1 : bPriority > aPriority ? -1 : 0
      })
    },
    productHostedSortedResults () {
      const productHostedResults = this.results.filter(platform => {
        return !platform.preferred && platform.status === 'product_hosted'
      })
      return productHostedResults.sort(function (a, b) {
        return a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1
          : b.displayName.toLowerCase() > a.displayName.toLowerCase() ? -1
            : 0
      })
    }
  },
  beforeRouteEnter: (to, from, next) => {
    if (from.name === 'FinalSelection') {
      next(vm => {
        vm.clearChosenPlatforms()
        vm.clearWizard()
      })
      return
    }
    next()
  }
  // beforeRouteLeave (to, from, next) {
  //   // this.clearCurrentPlatform()
  //   console.log(to)
  // }
}
</script>

<style lang="scss">
.iphone-safari {
  .lookup {
    .body {
      &__left,
      &__right {
        height: calc(100vh - 228px);
        @include bp($medium) {
          height: calc(100vh - 8rem);
        }
      }
    }
    &__unselected {
      height: calc(100vh - 228px);
    }
  }
}
.lookup {
  &__head {
    // height: 8rem;
    height: 4.688rem;
    background: $lightBlue;
    padding: .75rem 2rem;
    display: flex;
    align-items: left;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);
    position: relative;
    z-index: 1;
    flex-flow: column nowrap;

    @include bp($small) {
      padding: .75rem 3rem;
    }

    h2 {
      color: $blue;
      font-weight: 600;
      margin: 0;
      order: 1;
    }
  }

  &__search {
    padding: 1rem;
    @include bp($small) {
      padding: 1rem 2.5rem;
    }

    form {
      width: 100%;
      justify-content: space-between;
      text-align: center;
      @include bp($small) {
        display: flex;
        text-align: left;
      }
    }

    &--input {
      position: relative;
      width: 100%;
      margin-bottom: 1rem;

      @include bp($small) {
        max-width: calc(75% - 1rem);
        margin-bottom: 0;
        margin-right: 1rem;
      }
    }

    &--clear-search {
      display: block;
      position: absolute;
      top: 1rem;
      right: 1rem;
      width: 1rem;
      height: 1rem;
      text-indent: -9999px;
      background: url('~@/assets/images/ui/x-blue.svg') center center no-repeat;
      background-size: contain;
    }

    .unum-field {
      margin: 0 1rem 0 0;
    }

    .button {
      flex: 0 0 auto;
      padding: 0.5rem 1rem;
      @include bp($small) {
        padding: .875rem 1.5rem;
      }
    }
  }

  &__body {
    display: flex;
    background: #fff;
    padding: 0; // 0 0 0 3rem;
    overflow: hidden;
    height: 100%;
    // height: calc(100% - 256px);
    // padding-top: 1.5rem;
  }

  .body {
    &__v-bar-content {
      position: relative;
    }
    &__left {
      width: 50%;
      border-right: .063rem solid $lightGrey;
      overflow: auto;
    }
    &__right {
      // width: calc(50% - .063rem);
      width: 50%;
      background: #fff;
    }

    &__left,
    &__right {
      height: calc(100vh - 152px);
      @include bp($medium) {
        height: calc(100vh - 8rem);
      }
    }
  }

  &__unselected {
    position: relative;
    height: calc(100vh - 152px);
    padding: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-repeat: no-repeat;
    background-position: 73% bottom;
    background-size: auto 125%;
    background-image: url('~@/assets/images/bg-woman-laptop-2021.jpg');
    @include bp($medium) {
      height: calc(100vh - 155px);
    }
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.3);
    }
    .button {
      position: relative;
      border: 0;
    }
  }
  .platform-priority {
    color: #666;
    font-size: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Lookup.vue